/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'@ba/ba-ui-carbon',
	'react',
	'prop-types'
], function (Carbon, React, PropTypes) {

	const { Component } = React;
	const { Modal } = Carbon;

	class TemplateSelectDialog extends Component {

		constructor(props) {
			super(props);
			this.state = {
				isOpen: true
			};
		}

		render() {
			return (
				<Modal
					open={this.state.isOpen}
					size={this.props.size}
					modalHeading={this.props.modalHeading}
					primaryButtonText={this.props.primaryButtonText}
					secondaryButtonText={this.props.secondaryButtonText}
					className={this.props.className}
					hasScrollingContent={this.props.hasScrollingContent}
					hasForm={this.props.hasForm}
					onRequestClose={() => {
						this.setState({ isOpen: false });
						this.props.onRequestClose();
					}}
					onRequestSubmit={() => {
						this.setState({ isOpen: false });
						this.props.onRequestSubmit();
					}}
				>
					{this.props.children}
				</Modal>
			);
		}
	}

	TemplateSelectDialog.propTypes = {
		onRequestClose: PropTypes.func.isRequired,
		onRequestSubmit: PropTypes.func.isRequired,
		primaryButtonText: PropTypes.string.isRequired,
		size: PropTypes.string,
		modalHeading: PropTypes.string,
		secondaryButtonText: PropTypes.string,
		className: PropTypes.string,
		hasScrollingContent: PropTypes.bool,
		hasForm: PropTypes.bool,
		children: PropTypes.any
	};

	return TemplateSelectDialog;
});
